import styled from 'styled-components';

export const Icon = styled.img`
  height: 72px;
`;

export default Icon;
